module.exports = __webpack_public_path__ + "static/media/in-progress_icon.3ca23354.svg";